import { Component, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { RowComponent } from '@schoolbelle/common/table';
import { FormControl } from '@angular/forms';
import { merge } from 'rxjs';
import { MailmergeTableService } from '../mailmerge-table.service';
import { GroupMember, GroupMemberType } from '@schoolbelle/api/group-member';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: '[mailmerge-row]',
  templateUrl: './mailmerge-row.component.html',
  styleUrls: ['./mailmerge-row.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class MailmergeRowComponent extends RowComponent {
  @Input() memberType:GroupMemberType;
  @Input() memberMatchRequired:boolean;
  rowCtrl:FormControl;
  constructor(
    cdRef:ChangeDetectorRef,
    private mailmergeTableService:MailmergeTableService,
  ) { 
    super(cdRef);
  }


  ngOnInit() {
    super.ngOnInit();
    
    this.rowCtrl = new FormControl();
    if (this.tableForm) this.tableForm.setControl(`${this.row.y}`, this.rowCtrl);
    // update validity on resize change and search cell value change

    // on resize and value change, updateValidity and update the view.
    this.subscription.add(
      merge(
        this.row.onSizeChange,
        this.row.onChanged,
      )
      .pipe(
        debounceTime(0)
      )
      .subscribe(()=>{
        this.updateValidity()
        this.cdRef.detectChanges(); 
      })
    )

    // validate inital values
    this.updateValidity();
  }

  private member:GroupMember;
  private matchMember () {
    let member_n:GroupMember;
    const [query_in_classes, query_in_types, query_in_members] = this.row.cells.slice(0, 4).map(c=>c.val);

    if (query_in_members && query_in_classes) {
      member_n = this.mailmergeTableService.findMember(query_in_members, query_in_types ? query_in_types : this.memberType, query_in_classes, undefined)[0];
    }  
    else if (query_in_members) {
      member_n = this.mailmergeTableService.findMemberDirectly(query_in_members, this.memberType as any);
    }
    // const member_o = this.row.cells[0].get('member');
    const member_o = this.member;
    if (member_n) {
      if (member_o && member_o.member_id === member_n.member_id) return;     
      // this.row.cells[0].set('member', member_n);      
      this.member = member_n;      
    } else {
      if (!member_o) return;
      // this.row.cells[0].set('member', null);      
      this.member = null;      
    }
  }


  private updateValidity () {
    this.matchMember();
    // const member = this.row.cells[0] && this.row.cells[0].get('member');
    const member = this.member;
    const valid_query_string_length = this.row.cells.slice(0, 4).map(c=>c.val).filter(v=>v).length;
    // no query strings, no error, member matched, no error.
    if (valid_query_string_length === 0 || member) {
      if (this.rowCtrl && this.rowCtrl.invalid) {
        this.rowCtrl.setErrors(null);
        this.row.cells.slice(0, 4).forEach(c=>c.invalid = false);
      }  
    } 
    // query strings present, no member matched, throw error.
    else {
      if (this.rowCtrl && !this.rowCtrl.invalid && this.memberMatchRequired) {
        this.rowCtrl.setErrors({noMatchFound:true});
        this.row.cells.slice(0, 4).forEach(c=>c.invalid = true);
      }  
    }
    this.cdRef.detectChanges();
  }
}
